import { Component, Input, OnInit } from '@angular/core';
import { IPolicyGroupInfo } from 'src/app/core/interfaces/shared/components/IPolicyGroupInfo';

@Component({
  selector: 'app-policy-list-group',
  templateUrl: './policy-list-group.component.html',
  styleUrls: ['./policy-list-group.component.scss']
})
export class PolicyListGroupComponent implements OnInit {

  @Input() group: IPolicyGroupInfo;

  constructor() { }

  ngOnInit(): void {
  }

  get_class_by_name() {
    switch(this.group.name){
      case "Pendientes": return "red";
      case "En espera": return "yellow";
      case "Aprobados": return "blue";
      default: return "black";
    }
  }

}
